/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

const selfRegistration = {
  '': '/midas/settings/self-registration',
};

export default selfRegistration;
